/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type OnboardingOrgInviteQueryVariables = {
    queryInput: string;
    orgRelayId: string;
    excludeCalendars?: Array<string | null> | null | undefined;
};
export type OnboardingOrgInviteQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"OnboardingOrgInvite_viewer">;
    };
};
export type OnboardingOrgInviteQuery = {
    readonly response: OnboardingOrgInviteQueryResponse;
    readonly variables: OnboardingOrgInviteQueryVariables;
};



/*
query OnboardingOrgInviteQuery(
  $queryInput: String!
  $orgRelayId: ID!
  $excludeCalendars: [String]
) {
  viewer {
    ...OnboardingOrgInvite_viewer_1L0Few
    id
  }
}

fragment CopyPersonalInviteLinkBtn_user on User {
  id
}

fragment OnboardingOrgInvite_viewer_1L0Few on Viewer {
  user {
    ...CopyPersonalInviteLinkBtn_user
    id
  }
  personQueryResultErrorable(query: $queryInput, orgRelayId: $orgRelayId, excludeCalendars: $excludeCalendars) {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on PersonQueryResult {
      query
      persons {
        id
        primaryEmail
        emails
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
        isUser
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "excludeCalendars"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryInput"
    } as any, v3 = {
        "kind": "Variable",
        "name": "excludeCalendars",
        "variableName": "excludeCalendars"
    } as any, v4 = {
        "kind": "Variable",
        "name": "orgRelayId",
        "variableName": "orgRelayId"
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "OnboardingOrgInviteQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "kind": "Variable",
                                    "name": "queryInput",
                                    "variableName": "queryInput"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "OnboardingOrgInvite_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v2 /*: any*/),
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "OnboardingOrgInviteQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v5 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "kind": "Variable",
                                    "name": "query",
                                    "variableName": "queryInput"
                                }
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "personQueryResultErrorable",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "__typename",
                                    "storageKey": null
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "statusCode",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "message",
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "GraphEntityError",
                                    "abstractKey": null
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "query",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Person",
                                            "kind": "LinkedField",
                                            "name": "persons",
                                            "plural": true,
                                            "selections": [
                                                (v5 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "primaryEmail",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "emails",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "UserProfile",
                                                    "kind": "LinkedField",
                                                    "name": "profile",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "givenName",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "familyName",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "externalImageUrl",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "isYou",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "isUser",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "PersonQueryResult",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v5 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "10e0de7af690add93347241089cac21a",
            "id": null,
            "metadata": {},
            "name": "OnboardingOrgInviteQuery",
            "operationKind": "query",
            "text": "query OnboardingOrgInviteQuery(\n  $queryInput: String!\n  $orgRelayId: ID!\n  $excludeCalendars: [String]\n) {\n  viewer {\n    ...OnboardingOrgInvite_viewer_1L0Few\n    id\n  }\n}\n\nfragment CopyPersonalInviteLinkBtn_user on User {\n  id\n}\n\nfragment OnboardingOrgInvite_viewer_1L0Few on Viewer {\n  user {\n    ...CopyPersonalInviteLinkBtn_user\n    id\n  }\n  personQueryResultErrorable(query: $queryInput, orgRelayId: $orgRelayId, excludeCalendars: $excludeCalendars) {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on PersonQueryResult {\n      query\n      persons {\n        id\n        primaryEmail\n        emails\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n        isUser\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '837c5cd782b9ab6c3acdbb200a156759';
export default node;
